import { makeStyles } from "@mui/styles";
import React from "react";
import { HeaderMenu } from "../components/Header";
import HistoryTimeline from "../components/Timeline";
import { Typography } from "../components/Typography";
import img_history from "../asset/img_history.png";
import halfCircleBlue from "../asset/half_circle_blue.png";
import { MobileWeb } from "../components/mobile/BreakPoint";
import { Theme } from "@mui/material";
import MobileTimeline from "../components/mobile/MobileTimeline";
import { Footer } from "../components/Footer";
import { MobileFooter } from "../components/mobile/MobileFooter";

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    width: "100%",
    height: "100vh",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    margin: "0px auto",
    [theme.breakpoints.down(MobileWeb.mobile)]: {
      maxWidth: 824,
      width: "100%",
      margin: "0px",
      height: "100%",
      minWidth: "auto",
    },
  },
  body: {
    alignItems: "center",
    width: "100%",
    height: "100%",
    minHeight: 900,
    alignSelf: "center",
    textAlign: "center",
    position: "relative",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    borderTop: "1px solid #0000003b",
    [theme.breakpoints.down(MobileWeb.mobile)]: {
      maxWidth: 824,
      width: "auto",
      height: "100%",
      margin: "12px 20px",
      borderTop: "none",
    },
  },
  topTitle: {
    display: "flex",
    width: 790,
    [theme.breakpoints.down(MobileWeb.mobile)]: {
      width: "auto",
      marginTop: 50,
    },
  },
  top_titleText: {
    position: "relative",
    display: "flex",
    justifyContent: "center",
    color: "#204FA1",
    // marginTop: "90px",
    maxWidth: 1290,
    fontSize: "18px",
    right: 60,
    [theme.breakpoints.down(MobileWeb.mobile)]: {
      // margin: "75px 0px",
      right: 83,
    },
  },

  timeline: {
    display: "block",
    zIndex: 10,
    width: 900,
    [theme.breakpoints.down(MobileWeb.mobile)]: {
      display: "none",
    },
  },
  mobileTimeline: {
    display: "none",
    zIndex: 10,
    [theme.breakpoints.down(MobileWeb.mobile)]: {
      display: "block",
    },
  },
  imgBox: {
    width: "100%",
    height: 130,
    position: "relative",
    background: "#fdf5fd",
    [theme.breakpoints.down(MobileWeb.mobile)]: {
      width: "100%",
      height: 242,
    },
  },
  img: {
    position: "relative",
    width: 545,
    height: 343,
    left: 375,
    bottom: 230,
    backgroundColor: "transparent",
    [theme.breakpoints.down(MobileWeb.mobile)]: {
      width: "100%",
      left: 0,
      bottom: 0,
      height: "auto",
      marginRight: 0,
    },
  },
  halfCircleBlue: {
    position: "relative",
    bottom: 25,
    right: 45,
    width: 65,
    [theme.breakpoints.down(MobileWeb.mobile)]: {
      right: 70,
      bottom: 22,
    },
  },
}));

const HistoryPage = () => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <HeaderMenu />
      <div className={classes.body}>
        <div className={classes.topTitle}>
          <img
            src={halfCircleBlue}
            alt="blueHalfCircle"
            className={classes.halfCircleBlue}
          />
          <Typography variant="H3" className={classes.top_titleText}>
            연혁
          </Typography>
        </div>
        <div className={classes.timeline} style={{}}>
          <HistoryTimeline />
        </div>
        <div className={classes.mobileTimeline}>
          <MobileTimeline />
        </div>
        <div className={classes.imgBox}>
          <img src={img_history} alt="history_img" className={classes.img} />
        </div>
      </div>
      <Footer />
      <div style={{ display: "flex" }}>
        <MobileFooter />
      </div>
    </div>
  );
};

export default HistoryPage;
